import { TFunction } from 'i18next'

import { MissingCompanyDetails } from '@features/invoices/types/missingCompanyDetails'

import { ResolvedLabel } from '../../../../../../../hooks/useResolveTaxAndRegistrationNoLabel'

interface GetMissingCompanyDetailsListSubItemsOptions {
  isFrenchCompliance: boolean
  missingCompanyDetails?: MissingCompanyDetails
  resolvedTaxAndRegistrationNoLabel: ResolvedLabel
  t: TFunction
}

export const getMissingCompanyDetailsListSubItems = ({
  isFrenchCompliance,
  missingCompanyDetails,
  resolvedTaxAndRegistrationNoLabel,
  t,
}: GetMissingCompanyDetailsListSubItemsOptions) => {
  const {
    isMissingCompanyCity,
    isMissingCompanyLegalStatus,
    isMissingCompanyPaymentInfo,
    isMissingCompanyPobox,
    isMissingCompanyRegistrationNo,
    isMissingCompanySharedCapital,
    isMissingCompanyStreet,
    isMissingCompanyTaxInfo,
    isMissingCompanyVatNo,
  } = missingCompanyDetails || {}
  const { registrationNoLabel, vatNoLabel } = resolvedTaxAndRegistrationNoLabel

  const taxSubItems = isFrenchCompliance
    ? [
        {
          isMissing: isMissingCompanyVatNo,
          label: vatNoLabel,
        },
        {
          isMissing: isMissingCompanyRegistrationNo,
          label: registrationNoLabel,
        },
      ]
    : [
        {
          isMissing: isMissingCompanyTaxInfo,
          label: t(
            'external_invoices.send_e_invoice_requirements.modal.section_message.list.company_details.subitem.vat_details',
            { vatNo: vatNoLabel, registrationNo: registrationNoLabel },
          ),
        },
      ]

  return [
    {
      isMissing: isMissingCompanyCity,
      label: t('external_invoices.send_e_invoice_requirements.modal.section_message.list.company_details.subitem.city'),
    },
    {
      isMissing: isMissingCompanyStreet,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.company_details.subitem.street',
      ),
    },
    {
      isMissing: isMissingCompanyPobox,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.company_details.subitem.pobox',
      ),
    },
    {
      isMissing: isMissingCompanyLegalStatus,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.company_details.subitem.legal_status',
      ),
    },
    {
      isMissing: isMissingCompanySharedCapital,
      label: t(
        'external_invoices.send_e_invoice_requirements.modal.section_message.list.company_details.subitem.shared_capital',
      ),
    },
    ...taxSubItems,
    {
      isMissing: isMissingCompanyPaymentInfo,
      label: t('external_invoices.send_e_invoice_requirements.modal.section_message.list.company_details.subitem.iban'),
    },
  ]
    .filter((requirement) => requirement.isMissing)
    .map((requirement) => requirement.label)
}
